import { Crown } from "@/components/brand/Doodles";

const OFFSETS = [[0, -2], [-0.04, 1], [0.02, -1], [-0.02, 2], [0.04, 0]];

const bounce = (text) =>
  [...text].map((ch, i) => {
    const [y, r] = OFFSETS[i % OFFSETS.length];
    return <span key={i} className="inline-block" style={{ transform: `translateY(${y}em) rotate(${r}deg)` }}>{ch === " " ? "\u00A0" : ch}</span>;
  });

export const Brush = ({ lines, className = "", rotate = -8, as: Tag = "p", halo = true, testid }) => (
  <Tag className={`font-brush uppercase leading-[0.92] ${halo ? "spray" : ""} ${className}`} style={{ transform: `rotate(${rotate}deg)` }} aria-label={lines.join(" ")} data-testid={testid}>
    {lines.map((l) => <span key={l} aria-hidden="true" className="block whitespace-nowrap">{bounce(l)}</span>)}
  </Tag>
);

export const GoodPeopleMark = ({ className = "", susClass = "text-concrete", testid }) => (
  <p className={`relative font-brush uppercase leading-[0.92] ${className}`} style={{ transform: "rotate(-8deg)" }} aria-label="Good people. Sus ideas." data-testid={testid}>
    <Crown className="absolute -top-[0.62em] left-[0.02em] !h-auto w-[0.8em]" size={48} />
    <span aria-hidden="true" className="spray block">
      <span className="block whitespace-nowrap">{bounce("Good")}</span>
      <span className="block whitespace-nowrap">{bounce("People.")}</span>
      <span className="block whitespace-nowrap">
        <span className={`font-hand mr-[0.12em] inline-block align-[0.2em] text-[0.5em] lowercase ${susClass}`} style={{ transform: "rotate(-10deg)" }}>sus</span>
        {bounce("Ideas.")}
      </span>
    </span>
  </p>
);
